import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import EmailsLogo from 'assets/images/icon-sections/emails.svg';
import { sections } from 'modules/communications/constants/sections';

type CommunicationsSidenavProps = {
  section: string;
  totalUnreadCommunications: number;
  handleToggleInboxSection: () => void;
  handleToggleSettingsSection: () => void;
};

const CommunicationsSidenav: FC<CommunicationsSidenavProps> = ({
  section,
  totalUnreadCommunications,
  handleToggleInboxSection,
  handleToggleSettingsSection,
}) => {
  const { t } = useTranslate();

  const isInboxView = section === sections.INBOX;

  return (
    <div
      className="nk-ibx-aside toggle-screen-lg"
      data-content="inbox-aside"
      data-toggle-overlay="true"
      data-toggle-screen="lg"
    >
      <div className="nk-ibx-nav overflow-hidden" data-simplebar="init">
        <div className="w-100 d-flex justify-content-center">
          <img
            src={EmailsLogo}
            alt="emails logo"
            className="mh-100px text-center my-2"
          />
        </div>

        <ul className="nk-ibx-menu">
          <li
            className={isInboxView ? 'active' : ''}
            onClick={handleToggleInboxSection}
          >
            <button
              type="button"
              className="btn btn-block nk-ibx-menu-item p-2 pl-1"
            >
              <em className="icon ni ni-send" />
              <span className="nk-ibx-menu-text">{t('Sent')}</span>
              <span
                className={`badge badge-pill ${
                  totalUnreadCommunications > 0 ? 'badge-primary' : 'badge-gray'
                }`}
              >
                {totalUnreadCommunications || 0}
              </span>
            </button>
          </li>

          <li
            className={!isInboxView ? 'active' : ''}
            onClick={handleToggleSettingsSection}
          >
            <button
              type="button"
              className="btn btn-block nk-ibx-menu-item p-2 pl-1 justify-content-start"
            >
              <em className="icon ni ni-setting" />
              <span className="nk-ibx-menu-text">{t('Settings')}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CommunicationsSidenav;
